export default __webpack_public_path__ + "static/media/img-0501-holy-see-half-face.2668cc6f.png";